import { MenuItem } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const NavMenuItem = ({icon, to, text, onClick = () => {}}) => {
    return (
        <MenuItem>
            <Link 
                onClick={onClick}
                to={to} 
                style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                {text} {icon}
            </Link>
        </MenuItem>
    )
}

export default NavMenuItem;